import { Dropdown, type DropdownOption } from '@/components/Dropdown';

type StatusTargetOption = DropdownOption;

interface BulkActionBarProps {
  selectedCount: number;
  onClearSelection: () => void;
  targetStatusOptions: StatusTargetOption[];
  selectedTargetStatus: string;
  onTargetStatusChange: (value: string) => void;
  onChangeStatusClick: () => void;
}

export function BulkActionBar({
  selectedCount,
  onClearSelection,
  targetStatusOptions,
  selectedTargetStatus,
  onTargetStatusChange,
  onChangeStatusClick,
}: BulkActionBarProps) {
  const hasSelection = selectedCount > 0;
  const changeStatusDisabled = targetStatusOptions.length === 0;

  return (
    <div
      className={`flex items-center justify-between border-b border-gray-200 bg-red-50 px-6 py-3 ${
        hasSelection ? '' : 'pointer-events-none invisible'
      }`}
      aria-hidden={!hasSelection}
    >
      <span className="text-sm font-medium text-gray-900">
        {selectedCount} claim{selectedCount === 1 ? '' : 's'} selected
      </span>
      <div className="flex items-center gap-3">
        <button
          type="button"
          onClick={onClearSelection}
          tabIndex={hasSelection ? 0 : -1}
          className="text-sm font-medium text-gray-600 hover:text-gray-800"
        >
          Clear selection
        </button>
        <div className="w-40" title={changeStatusDisabled ? 'No eligible claims' : undefined}>
          <Dropdown
            value={selectedTargetStatus}
            onChange={onTargetStatusChange}
            options={targetStatusOptions}
            disabled={changeStatusDisabled}
            ariaLabel="Target status"
            placeholder="No status change available"
          />
        </div>
        <button
          type="button"
          onClick={onChangeStatusClick}
          disabled={changeStatusDisabled}
          tabIndex={hasSelection ? 0 : -1}
          title={changeStatusDisabled ? 'No eligible claims' : undefined}
          className="rounded-md bg-red-600 px-4 py-2 text-sm font-medium text-white hover:bg-red-700 disabled:cursor-not-allowed disabled:bg-gray-300 disabled:text-gray-500 hover:disabled:bg-gray-300"
        >
          Change status
        </button>
      </div>
    </div>
  );
}
